<template>
  <div class="summary-card-header">
    <span class="card-header__title">
      {{$t('feed.audit.likesAndReposts.period')}}:
      <b>{{periodName}}</b>
    </span>
    <period-range :chart-name="chartName"/>
  </div>
</template>

<script>
  // components
  import PeriodRange from "../../../../../../../../components/auditPeriodRange/PeriodRange";

  export default {
    name: "SummaryLikesAndRepostsHeader",
    props: {
      chartName: {
        type: String
      }
    },
    computed: {
      periodName() {
        return this.$store.getters.auditPeriodName(this.chartName, this.$i18n);
      }
    },
    components: {
      PeriodRange
    }
  };
</script>

<style>
  @import "../../../../../../../../style/cardHeaderTitle.css";
  .summary-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>
